import * as angular from 'angular';

import { IRequestService } from '../../services';

export interface IExportSvgService {
    exportSvgAsPng(fileName: string, svgElement: SVGSVGElement): angular.IPromise<any>;
    exportSvg(fileName: string, svgElement: SVGSVGElement): angular.IPromise<any>;
    isExportPng(): boolean;
    isExportSvg(): boolean;
}

export class ExportSvgService implements IExportSvgService {
    static serviceId = 'exportSvgService';

    private _cssStyleSheet = 'content/svg.min.css';

    static $inject = ['$http', '$q'];

    constructor(
        private _$http: angular.IHttpService,
        private _$q: angular.IQService
    ) {
    }

    exportSvgAsPng(fileName: string, svgElement: SVGSVGElement): angular.IPromise<any> {
        const defered = this._$q.defer();

        const w = svgElement.width.baseVal.value;
        const h = svgElement.height.baseVal.value;

        // getting CSS to inject
        this._$http.get<string>(this._cssStyleSheet)
            .then(css => {
                const svg = this.getSvgString(css.data, svgElement, w, h);
                this.saveSvgAsPng(fileName, svg, w, h);
                defered.resolve();
            });

        return defered.promise;
    }

    exportSvg(fileName: string, svgElement: SVGSVGElement): angular.IPromise<any> {
        const defered = this._$q.defer();

        const w = svgElement.width.baseVal.value;
        const h = svgElement.height.baseVal.value;

        // getting CSS to inject
        this._$http.get<string>(this._cssStyleSheet)
            .then(css => {
                const svg = this.getSvgString(css.data, svgElement, w, h);
                this.saveSvg(fileName, svg);
                defered.resolve();
            });

        return defered.promise;
    }

    private saveSvg(fileName: string, svgString: string) {
        try {
            const nav = (window.navigator as any);
            if (nav.msSaveOrOpenBlob) {
                //IE code
                const blob = new Blob([`\uFEFF${decodeURIComponent(encodeURI(svgString))}`], {
                    type: 'image/svg+xml'
                });
                nav.msSaveBlob(blob, fileName + '.svg');
            } else {
                const type = 'data:image/svg+xml;utf-8';
                svgString = encodeURIComponent(svgString);
                const anchor = angular.element('<a/>');
                anchor.css({ display: 'none' });
                angular.element(document.body).append(anchor);

                (anchor.attr({
                    href: type + ',' + svgString,
                    target: '_blank',
                    download: fileName + '.svg'
                })[0]).click();

                anchor.remove();
            }

        } catch (e) {
            console.error(e);
        }
    }

    private getSvgString(css: string, svgElement: any, w: number, h: number): string {
        return `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" class="export">
                    <style type="text/css">svg{background-color:white!important;} .export .crosshair-group{visibility:hidden;display:none;} ${css}</style>
                    ${svgElement.innerHTML
                .replace(new RegExp('=\'\' ', 'g'), '=\"\" ')
                .replace(new RegExp('=\'\'/', 'g'), '=\"\"/')
                .replace(new RegExp('\'\'', 'g'), '\'')
                .replace(new RegExp('=\'>', 'g'), '=\"\">')
            }</svg>`;
    }

    private saveSvgAsPng(fileName: string, svgString: string, w: number, h: number): void {

        const canvas = document.getElementById('rendering') as HTMLCanvasElement;
        canvas.width = w;
        canvas.height = h;
        const context = canvas.getContext('2d');
        const image = new Image;

        image.onload = () => {
            this.printImage(context, image, fileName, canvas);
        };
        image.onerror = (e) => {
            console.error(e);
        };
        image.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`;
    }

    private printImage(context: CanvasRenderingContext2D, image, fileName, canvas: HTMLCanvasElement) {
        context.drawImage(image, 0, 0);
        const a = document.getElementById('download') as any;
        a.download = fileName + '.png';
        const dataUrl = canvas.toDataURL('image/png');
        a.href = dataUrl;
        a.click();
        context.clearRect(0, 0, canvas.width, canvas.height);
    }

    isExportPng(): boolean {
        const nav = (window.navigator as any);
        return !(nav.msSaveOrOpenBlob);
    }

    isExportSvg(): boolean {
        return true;
    }
}